import { SelectOption } from '../components';
import { SortField } from '../components/RatesTool/types';

export const ficoOptions: SelectOption[] = [
  { label: '740+', value: 740 },
  { label: '720-739', value: 720 },
  { label: '700-719', value: 700 },
  {
    label: '680-699',
    value: 680,
  },
  { label: '660-679', value: 660 },
  { label: '640-659', value: 640 },
  {
    label: '620-639',
    value: 620,
  },
  { label: '600-619', value: 600 },
  { label: '580-599', value: 580 },
  { label: '<580', value: 0 },
];

export const loanTypeOptions: SelectOption[] = [
  { value: 'conventional', label: 'Conventional' },
  { value: 'homeready', label: 'HomeReady' },
  { value: 'fha', label: 'FHA' },
  { value: 'va', label: 'VA' },
  { value: 'usda', label: 'USDA' },
];

export const offProductLoanTypeOptions: SelectOption[] = [
  { value: 'CONVENTIONAL', label: 'Conventional loan' },
  { value: 'FHA', label: 'FHA' },
  { value: 'VA', label: 'VA' },
  { value: 'USDA', label: 'USDA' },
  { value: 'FIRST_TIME_HOMEBUYER', label: 'First-time homebuyer programs' },
  { value: 'DOWN_PAYMENT_ASSISTANCE', label: 'Down payment assistance' },
  { value: 'JUMBO', label: 'Jumbo loan' },
  { value: 'PROFESSIONAL', label: 'Professional loan' },
  { value: 'INVESTOR_DSCR', label: 'Investor DSCOR loan' },
  { value: 'INVESTOR_HARD_MONEY', label: 'Investor hard money loan' },
  { value: 'BANK_STATEMENT', label: 'Bank statement loan' },
  { value: 'RENOVATION', label: 'Renovation loan' },
  { value: 'HOME_EQUITY', label: 'Home equity loan' },
  { value: 'HOME_EQUITY_LINE_OF_CREDIT', label: 'Home equity line of credit' },
  { value: 'CONSTRUCTION', label: 'Construction loan' },
  { value: 'BRIDGE', label: 'Bridge loan' },
  { value: 'REFINANCE_CASH_OUT', label: 'Refinance (cash out)' },
  { value: 'REFINANCE_RATE_TERM', label: 'Refinance (rate/term)' },
  { value: 'OTHER', label: 'Other' },
];

export const occupancyTypeOptions: SelectOption[] = [
  { value: 'primary', label: 'Primary home' },
  { value: 'secondary', label: 'Secondary home' },
  { value: 'investment', label: 'Investment home' },
];

export const residenceTypeOptions: SelectOption[] = [
  { value: 'single_family', label: 'Single family' },
  { value: 'condo', label: 'Condo' },
  { value: 'coop', label: 'Co-op' },
  { value: 'multi_family', label: 'Multi family' },
  { value: 'other', label: 'Other' },
];

export const numUnitsOptions: SelectOption[] = [
  { value: 1, label: '1 unit' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
];

export const loanTermOptions: SelectOption[] = [
  { value: 'FX30YR', label: '30 year' },
  { value: 'FX20YR', label: '20 year' },
  { value: 'FX15YR', label: '15 year' },
  { value: 'ARM10_6', label: '10/6 ARM' },
  { value: 'ARM7_6', label: '7/6 ARM' },
  { value: 'ARM5_6', label: '5/6 ARM' },
];

export const sortFieldDisplay: Record<SortField, string> = {
  [SortField.Apr]: 'APR',
  [SortField.LoanCosts]: 'Loan costs',
  [SortField.PrincipalAndInterest]: 'Principal & interest',
  [SortField.Rate]: 'Rate',
};

export const sortFieldOptions: SelectOption[] = Object.keys(SortField).map(
  (key) => {
    return {
      value: (SortField as any)[key],
      label: sortFieldDisplay[(SortField as any)[key] as SortField],
    };
  }
);
